import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// The Blog (code name "Footprint") now lives inside the Bulletin (Sam,
// 2026-09-26). Old /footprint links -- including the ones written into the
// pieces themselves, like /footprint?tab=history#a-appendix -- land on the same
// section and piece there. Its own file so a test can check it without the app.
function FootprintRedirect() {
  const { search, hash } = useLocation();
  const section = new URLSearchParams(search).get("tab");
  const next = new URLSearchParams({ view: "blog" });
  if (section) next.set("section", section);
  return <Navigate to={`/bulletin?${next.toString()}${hash}`} replace />;
}

export default FootprintRedirect;
